module.exports = "<md-toast class=\"md-warn stale-student-toast\"> <span class=\"md-toast-text\" flex> {{message}} </span> </md-toast>\n"